@if (smartphoneURL$ | async) {
  <div class="bg-[#f8f8f8] p-6 rounded asset-group w-fit relative">
    @if (isCreationProcess$ | async) {
      <div class="upper-arrow"></div>
    }
    @if ((isCreationProcess$ | async) === false) {
      <div class="font-bold text-lg">
        {{ 'assets.splashscreens' | translate }}
      </div>
      <div class="mb-4">{{ 'assets.splashscreens-explained' | translate }}</div>
    }
    <div
      class="flex asset-group w-fit shrink-0 splashscreen-assets"
      [class.creation-process]="isCreationProcess$ | async"
      [class.update-process]="(isCreationProcess$ | async) === false"
      [style.gap.px]="assetGroupGap"
    >
      <!-- splashscreen smartphone asset -->
      <div
        class="flex flex-col gap-5 flex-1 asset-display-container"
        [style.width.px]="assetWidth"
      >
        <rk-asset-display
          [imageUrl]="smartphoneURL$ | async"
          assetKey="splashscreen"
          imageClass="absolute rounded-xl w-[82px] h-[145px] object-cover"
          (crop)="onCrop($event)"
          (replace)="onReplace('splashscreen')"
        ></rk-asset-display>
        <div>
          <div class="font-bold mb-1">{{ 'assets.smartphone' | translate }}</div>
          <div class="opacity-70 text-sm">
            {{ 'assets.smartphone-description' | translate }}
          </div>
        </div>
        <rk-infobox [type]="'info'" class="w-fit">
          <div class="font-bold text-sm">
            <fa-icon [icon]="'info-circle'"></fa-icon>
            {{ 'assets.restrictions' | translate }}
          </div>
          <div [innerHTML]="'assets.constraints-smartphone' | translate"></div>
        </rk-infobox>
      </div>

      <!-- splashscreen large asset -->
      <div
        class="flex flex-col gap-5 flex-1 asset-display-container"
        [style.width.px]="assetWidth"
      >
        <rk-asset-display
          [imageUrl]="smartphoneLargeURL$ | async"
          assetKey="splashscreenLarge"
          mockImage="/assets/splash-smartphonelarge-mock.png"
          mockImageClass="h-[149px] w-[69px]"
          imageClass="absolute rounded-[9px] w-[65px] h-[145px] object-cover"
          (crop)="onCrop($event)"
          (replace)="onReplace('splashscreenLarge')"
        ></rk-asset-display>
        <div>
          <div class="font-bold mb-1">
            {{ 'assets.smartphone' | translate }} -
            <span class="text-sm font-normal opacity-70">
              {{ 'assets.large-screen' | translate }}</span
            >
          </div>
          <div class="opacity-70 text-sm">
            {{ 'assets.smartphone-long-description' | translate }}
          </div>
        </div>
        <rk-infobox [type]="'info'" class="w-fit">
          <div class="font-bold text-sm">
            <fa-icon [icon]="'info-circle'"></fa-icon>
            {{ 'assets.restrictions' | translate }}
          </div>
          <div [innerHTML]="'assets.constraints-smartphone-long' | translate"></div>
        </rk-infobox>
      </div>

      <!-- splashscreen TV asset -->
      @if (availableOnAndroidTV$ | async) {
        <div
          class="flex flex-col gap-5 flex-1 asset-display-container"
          [style.width.px]="assetWidth"
        >
          <rk-asset-display
            [imageUrl]="tvSplashscreenURL$ | async"
            assetKey="splashscreenTv"
            mockImage="/assets/splash-tv-mock.png"
            mockImageClass="w-[150px] h-[102px]"
            imageClass="absolute rounded-[2px] left-[2px] w-[147px] h-[92px] mb-[8px] object-cover"
            (crop)="onCrop($event)"
            (replace)="onReplace('splashscreenTv')"
          ></rk-asset-display>
          <div>
            <div class="font-bold mb-1">{{ 'assets.tv' | translate }}</div>
            <div class="opacity-70 text-sm">
              {{ 'assets.tv-description' | translate }}
            </div>
          </div>
          <rk-infobox [type]="'info'" class="w-fit">
            <div class="font-bold text-sm">
              <fa-icon [icon]="'info-circle'"></fa-icon>
              {{ 'assets.restrictions' | translate }}
            </div>
            <div [innerHTML]="'assets.constraints-tv' | translate"></div>
            <p><br />{{ 'assets.restrictions-splashscreen-tv' | translate }}</p>
          </rk-infobox>
        </div>
      }

      <!-- splashscreen TV topshelf -->
      @if (availableOnAppleTV$ | async) {
        <div
          class="flex flex-col gap-5 flex-1 asset-display-container"
          [style.width.px]="assetWidth"
        >
          <rk-asset-display
            [imageUrl]="topShelfTvURL$ | async"
            assetKey="topShelfTv"
            imageClass="absolute rounded-[4px] w-[162px] h-[48px] object-cover left-[38px] top-[25px] "
            (crop)="onCrop($event)"
            (replace)="onReplace('topShelfTv')"
          ></rk-asset-display>
          <div>
            <div class="font-bold mb-1">
              {{ 'assets.topshelf-tv-short' | translate }} -
              <span class="text-sm font-normal opacity-70">
                {{ 'assets.apple-only' | translate }}</span
              >
            </div>
            <div class="opacity-70 text-sm">
              {{ 'assets.topshelf-tv-description' | translate }}
            </div>
          </div>
          <rk-infobox [type]="'info'" class="w-fit">
            <div class="font-bold text-sm">
              <fa-icon [icon]="'info-circle'"></fa-icon>
              {{ 'assets.restrictions' | translate }}
            </div>
            <div [innerHTML]="'assets.constraints-topshelf-tv' | translate"></div>
          </rk-infobox>
        </div>
      }
    </div>
  </div>
}
